import React, { useContext, useState, useEffect } from "react";
import { authService } from "../services/authService";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing session on component mount. If the access token is
    // expired (or expiring soon) but a refresh token is still available,
    // refresh it before rendering so the user stays signed in.
    const initializeAuth = async () => {
      const session = await authService.initializeSession();
      setUser(session?.user ?? null);
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const signIn = async (credentials) => {
    // Don't set loading here as it causes Login component to unmount/remount
    try {
      const result = await authService.signIn(credentials);

      // Only set user if login is successful AND not requiring OTP
      if (result.user && !result.requiresOTP) {
        setUser(result.user);
      }

      return result; // Return the full result object including requiresOTP
    } catch (error) {
      return { user: null, session: null, error: error.message };
    }
  };

  const signOut = async () => {
    setLoading(true);
    try {
      const result = await authService.signOut();
      setUser(null);
      setLoading(false);
      return result;
    } catch (error) {
      setLoading(false);
      return { error: error.message };
    }
  };

  const value = {
    signUp: (data) => authService.signUp(data),
    signIn,
    signOut,
    user,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
